const endYear = 1950;
const currentYear = new Date().getFullYear();
const years = [];

for (let i = currentYear; i >= endYear; i--) {
  years.push(i);
}

export default years;
